import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-491ba382")
const _hoisted_1 = { class: "data-item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cat-outer" }
const _hoisted_5 = { class: "cat-inner col-6" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "content" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.item.detailedViewUrl
    }, [
      _createElementVNode("img", {
        class: "thumbnail",
        src: _ctx.item.thumbnail
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.categories?.join(", ")), 1)
    ]),
    _createElementVNode("h3", null, [
      _createElementVNode("a", {
        href: _ctx.item.detailedViewUrl
      }, _toDisplayString(_ctx.item.title), 9, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.content), 1)
  ]))
}